import { useMemo } from "react";

import { useConfig } from "@jti/ui/hooks/useConfig";

import { useLocale } from "@/context/LocaleContext";
import { i18n } from "@/libs/i18n";

export const useLanguages = () => {
  const { languages } = useConfig();
  const { currentLocale = i18n.defaultLocale, locales } = useLocale();

  const languagesList = useMemo(() => {
    if (languages) {
      const filteredLanguagesList = languages
        .filter(({ locale }) => locale && locales.includes(locale))
        .map((language) => ({
          ...language,
          current: language.locale === currentLocale,
        }));

      return filteredLanguagesList.length > 1 ? filteredLanguagesList : [];
    }
    return [];
  }, [currentLocale, languages, locales]);
  return languagesList;
};
